var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMobileType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80285 21.6021C7.48747 22.4913 9.44206 23 11.5265 23C17.8629 23 23 18.299 23 12.5C23 6.70102 17.8633 2 11.5269 2C5.19054 2 0.0538743 6.70102 0.0538743 12.5C0.0538743 14.4077 0.609736 16.1965 1.58131 17.7382L1.58507 17.7442C1.67856 17.8925 2.20015 18.6417 2.2215 18.7124L0.698736 21.2293L0.697502 21.2329C0.37025 21.7168 0 22.3493 0 22.6557C0 22.8657 0.32194 22.8435 0.555375 22.8435C0.763672 22.8435 1.29587 22.6557 1.98077 22.4122L1.98846 22.4096L4.92871 21.5127C5.09612 21.4616 5.18123 21.4357 5.26212 21.4306C5.33754 21.4259 5.40259 21.4321 5.47544 21.4506C5.55289 21.4702 5.63467 21.5133 5.79759 21.5993L5.80285 21.6021Z",
    fill: "#0A88FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 12.5,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.5,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 12.5,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobileType);
export default __webpack_public_path__ + "static/media/ic_mobile_type.0ceddc198bbf74840bb3cd1400a62ee8.svg";
export { ForwardRef as ReactComponent };